import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppContext, loadEnvConfig } from 'sigv-lib-ui';
import {
  SYSTEM_CODE,
  SYSTEM_GROUP_CODE,
  SYSTEM_NAME,
} from './app/shared/constants/global-constants.constant';
import { environment } from './environments/environment';

globalThis.sigv = {
  appContext: new AppContext(),
};

loadEnvConfig()
  .then((json) => {
    globalThis.sigv.appContext.envConfig = json;
    globalThis.sigv.appContext.projectConfig.systemCode = SYSTEM_CODE;
    globalThis.sigv.appContext.projectConfig.systemGroupCode =
      json.systemGroupCode ?? SYSTEM_GROUP_CODE;
    globalThis.sigv.appContext.projectConfig.systemName = SYSTEM_NAME;
    globalThis.sigv.appContext.environment = environment;
    import('./app/app.module')
      .then((m) => m.AppModule)
      .then((x) => {
        platformBrowserDynamic()
          .bootstrapModule(x)
          .catch((err) => console.error(err));
      });
  })
  .catch((err) => console.error(err));
